var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('small-header',{attrs:{"navbar-index":"3"}}),_c('header-banner'),_c('wifi-crud-content'),_c('common-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }